// Website domain constants: the marketing site's routes, content types, SEO
// and the API documentation viewer.

export const SEO = {
  Types: {
    Article: "NewsArticle",
    Website: "Website",
  },
};

export const Content = {
  Types: {
    Foundation: "Foundation",
    Identity: "Identity",
    Publishing: "Publishing",
    Payment: "Payment",
    Messaging: "Messaging",
    Infrastructure: "Infrastructure",
    DevOps: "DevOps",
    ApiDevelopment: "ApiDevelopment",
    Announcement: "Announcement",
    PlatformEngineering: "PlatformEngineering",
    WebDevelopment: "WebDevelopment",
    MobileDevelopment: "MobileDevelopment",
    Marketplace: {
      AI: "AI-Marketplace",
    },
  },
};

export const Resources = {
  EngineeringRoadmap: "engineering-roadmap",
  Scoping: "scoping",
};

export const Routes = {
  Marketplace: {
    Contributors: {
      Directory: "/contributors",
      Profile: "/c",
      Pricing: "/company/pricing",
    },
    Projects: {
      Directory: "/projects",
      PostNewProject: "/projects/new",
      Project: "/project",
    },
    Models: {
      Start: "/start",
      Directory: "/models",
      Templates: {
        Python: "https://dev.azure.com/Pellerex/public/_git/Python.API.SDK",
      },
    },
    Dashboard: {
      Home: "/dashboard",
      Organisation: "/dashboard/organisation",
      Apps: "/dashboard/apps",
      AppSpace: "/dashboard/app",
      Support: "/dashboard/support",
      Products: "/dashboard/products",
      Inbox: "/dashboard/inbox",
      Profile: "/dashboard/profile",
    },
    Pages: {
      Home: "/",
      Landings: {
        Default: "/",
        Dashboard: "/dashboard",
        //This route will be retired by 1 March
        DataScientists1: "/build-ai-with-us",
        DataScientists: "/build",
        Monetisation: "/monetise",
      },

      Products: {
        Index: "/products",
        Foundation: {
          GetStarted: "/foundations/get-started",
          Base: "/foundation",
          List: "/foundations",
          Pellerex: "/pellerex",
          FoundationsInOnboardingMode: "/foundations?onboarding=true",
        },
        Service: {
          Base: "/service",
          List: {
            All: "/services",
            ManagedApiFoundation: {
              Submission: "/api/submit",
              Page: "/managed-api-service",
            },
          },
        },
        API: {
          Base: "/api",
          List: {
            All: "/apis",
          },
        },
        Model: {
          Base: "/model",
          List: "/models",
        },
        APIs: "/apis",
      },
      Resources: {
        Base: "/resource?id={resourceId}",
        ScopingOutput: "/resource/scoping/output",
      },
      Blogs: {
        Directory: "/blog/list",
        FederatedGovernance: "/blog/federated-governance",
        ApiVersioning: "/blog/asp-net-core-web-api-versioning",
        WhatIsPellerex: "/blog/what-is-pellerex-foundation",
        URLRewrite: "/blog/url-rewrite-aspnet-core",
        Authentication:
          "/blog/react-redux-jwt-axios-asp-net-core-authentication-authorisation",
        AspNetCoreSetup: "/blog/asp-net-core-api-setup",
        ApiConfigManagement: "/blog/asp-net-5-web-api-configuration-management",
        ApiSecretManagement: "/blog/asp-net-5-web-api-secret-management",
        ApiMonitoring: "/blog/asp-net-5-web-api-monitoring",
        ApiDatabaseSetup:
          "/blog/database-setup-for-aspnet-5-web-api-with-entity-framework-and-sql",
        ApiDocumentation: "/blog/asp-net-5-api-documentation-with-swagger",
        ApiCors: "/blog/asp-net-5-cors",
        ApiFluentValidation:
          "/blog/asp-net-5-request-validation-with-fluent-validation",
        ApiExceptionHandling: "/blog/asp-net-5-global-exception-handling",
        AppSetup: "/blog/spa-with-asp-net-5-react-and-redux",
        AppThemeManagement: "/blog/spa-styling-and-theme-management-with-scss",
        AppGlobalNavigation: "/blog/spa-mobile-first-global-navigation",
        AppLayout: "/blog/spa-layout",
        AppForms: "/blog/spa-forms",
        AppRouting: "/blog/spa-routing",
        AppConfiguration: "/blog/spa-configuration",
        AppApiCall: "/blog/spa-api-call",
        AppMonitoring: "/blog/spa-monitoring",
        AppNotification: "/blog/spa-notification",
        AppRedux: "/blog/spa-react-redux",
        AppGoogleMaps: "/blog/spa-google-maps-polygons",
        AppSEO: "/blog/spa-react-seo",
        AppShellConfiguration: "/blog/spa-aspnet-react-configuration",
        AppAzureDeploy: "/blog/spa-deploy-aspnet-with-react-using-azure-devops",
        ApiIdentityDbSetup: "/blog/auth-identity-db-setup",
        ApiIdentityEmailSender: "/blog/auth-email-sender",
        IdentitySignUp: "/blog/identity-sign-up",
        IdentityGoogleAuth: "/blog/google-auth-for-react-with-aspnet-identity",
        IdentityMicrosoftAuth:
          "/blog/microsoft-auth-for-react-with-aspnet-identity",
        IdentityTwitterAuth:
          "/blog/twitter-auth-for-react-with-aspnet-identity",
        ApiCallOtherApis: "/blog/asp-net-core-api-call-other-apis",
        AppAuthStatusCheck: "/blog/identity-authenticated-hoc",
        IdentityChangePassword: "/blog/identity-change-password",
        IdentitySignIn: "/blog/identity-sign-in",
        IdentityClaimBasedAccessManagement:
          "/blog/claim-based-access-management",
        IdentityTokenRefresh: "/blog/identity-token-refresh",
        PaymentWithStripe: "/blog/payment-with-stripe",
        PaymentCaptureCardDetails:
          "/blog/capture-card-details-with-react-and-stripe-elements",
        PaymentOneTimeWithStripe: "/blog/process-one-time-payment-with-stripe",
        PaymentSubscriptionsWithStripe:
          "/blog/process-subscriptions-using-stripe",
        ApiLoggingWithSeriLog: "/blog/structured-logging-with-serilog",
        SoftwareRoadmap:
          "/blog/technologyleads-software-transformation-roadmap",
        TopLowCodePlatforms: "/blog/top-low-code-platform",
        ApiContainerisation: "/blog/containerise-aspnet-api",
        AppContainerisation:
          "/blog/containerise-react-app-with-aspnet-and-azure-devops",
        BoilerPlateSolutions: "/blog/aspnet-boiler-plate-solutions",
        DockerComposeMultiContainerApps:
          "/blog/docker-compose-for-multi-container-apps",
        MinikubeSetup: "/blog/run-aspnet-api-and-react-apps-on-minikube",
        KubernetesSetup: "/blog/kubernetes-with-aspnet-react-and-azure-devops",
        EventDrivenArchitecture:
          "/blog/event-driven-architecture-with-pellerex",
        CommandsCheatSheet: "/blog/commands-cheat-sheet",
        PerformanceAndCostOptimisation:
          "/blog/performance-and-cost-optimisation",
        ChatUsingSignalR: "/blog/realtime-chat-with-signalR-dotnet-k8s",
        AzureDevOpsRestAPIs: "/blog/foundation/azure-devops-rest-apis",
        AzureDevOpsCreateProject:
          "/blog/foundation/create-azure-devops-project",
        AzureDevOpsFetchProjects:
          "/blog/foundation/fetch-azure-devops-projects",
        AzureDevOpsInviteUsers:
          "/blog/foundation/invite-users-to-azure-devops-organisation",
        AzureDevOpsCreateSecurityGroup:
          "/blog/foundation/create-azure-devops-security-group",
        PellerexV2Release: "/blog/pellerex-v2-release",
        PellerexOnAzureMarketplace:
          "/blog/pellerex-products-on-azure-marketplace",
        DeployAIModels: "/blog/top-10-ways-to-deploy-ai-models-to-production",
        LoggingWithPellerex: "/blog/cloud-native-api-logging-with-pellerex",
        PellerexManagedApiService: "/blog/pellerex-managed-api-service",
        PellerexSecretManagement: "/blog/pellerex-secret-management",
        PlatformEngineering: "/blog/platform-engineering",
        DxcPartnership: "/blog/dxc-partnership",
      },
      FAQs: {
        Base: "/faqs",
        ModelPerformanceReports: "/model-performance",
        CreatorRightsProtection: "/creator-right-protection",
        RunTimeArchitecture: "/runtime-architecture",
      },
      Terms: "/terms",
      Policies: "/policies",
      LogIn: "/auth",
      Conversion: {
        GettingStarted: "/getting-started",
        Licensing: {
          PaymentAuthorisation: "/registration/payment-authorisation",
          PaymentAuthorisationRedirect:
            "/registration/payment-authorisation-redirect",
          Confirmation: "/registration/confirmation",
        },
        //To be consolidated with talk to expert
        PlatformSupport: "/contact/support",
        ProductSupport:
          "/contact/support?appSpaceId={appSpaceId}&productId={productId}",
        Demo: "/demo",
        TalkToExpert: "/contact/expert",
        Acknowledge: "/contact/message/received",
        Types: {
          BlogSubscription: {
            Key: "NewsletterSubscription",
            Header: "All done. ",
            Message:
              "From now on, we will notify you whenever we have updates.",
          },
          ContactUs: {
            Key: "TalkToUs",
            Header: "All done.",
            Message: "One of our team members will be in touch shortly.",
          },
        },
      },
    },
  },
  Foundation: {
    Root: "https://pellerex.com",
    Messaging: "https://pellerex.com/messaging",
    Identity: "https://pellerex.com/identity",
    Payment: "https://pellerex.com/payment",
    Kits: "https://pellerex.com/kits",
    Demo: "https://pellerex.com/demo",
  },
};

export const ApiDocumentation = {
  Language: "curl",
  Variant: "cURL",
  Theme: "javascript",
  Languages: [
    {
      language: "curl",
      variant: "cURL",
      theme: "javascript",
    },
    {
      language: "javascript",
      variant: "Fetch",
      theme: "javascript",
    },
    {
      language: "nodejs",
      variant: "request",
      theme: "javascript",
    },
    {
      language: "nodejs",
      variant: "Axios",
      theme: "javascript",
    },
    {
      language: "csharp",
      variant: "RestSharp",
      theme: "csharp",
    },
    {
      language: "php",
      variant: "cURL",
      theme: "php",
    },
    {
      language: "powershell",
      variant: "RestMethod",
      theme: "powershell",
    },
    {
      language: "python",
      variant: "http.client",
      theme: "python",
    },
    {
      language: "shell",
      variant: "wget",
      theme: "shellSession",
    },
    {
      language: "go",
      variant: "Native",
      theme: "go",
    },
    {
      language: "swift",
      variant: "URLSession",
      theme: "swift",
    },
    {
      language: "http",
      variant: "HTTP",
      theme: "javascript",
    },
    {
      language: "java",
      variant: "OkHttp",
      theme: "java",
    },
    {
      language: "javascript",
      variant: "jQuery",
      theme: "javascript",
    },
    {
      language: "javascript",
      variant: "XHR",
      theme: "javascript",
    },
  ],
};
